import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, MapPin, ArrowRight } from 'lucide-react';
import { RevealItem } from './motion/Reveal';

const formatDate = (value) => {
  if (!value) return '';
  const d = new Date(value);
  if (isNaN(d)) return String(value).slice(0, 20);
  return d.toLocaleDateString('en-NG', { year: 'numeric', month: 'short', day: 'numeric' });
};

export const ArticleCard = ({ article, index = 0 }) => (
  <RevealItem>
    <Link
      to={`/property-hub/${article.slug}`}
      data-testid={`article-card-${article.slug}`}
      className="group block h-full bg-white border border-stone-200 rounded-3xl overflow-hidden hover:border-emerald-300 hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
    >
      <div className="relative h-52 overflow-hidden bg-stone-100">
        <img
          src={article.featured_image}
          alt={article.title}
          loading="lazy"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-4 left-4 px-3 py-1.5 bg-emerald-700 text-white text-xs font-medium rounded-full">
          {article.category}
        </span>
      </div>
      <div className="p-6">
        <h3 className="text-xl font-medium text-stone-800 mb-3 leading-snug group-hover:text-emerald-700 transition-colors line-clamp-2">
          {article.title}
        </h3>
        <p className="text-stone-600 text-sm leading-relaxed mb-5 line-clamp-3">{article.summary}</p>
        <div className="flex items-center justify-between text-xs text-stone-500">
          <span className="flex items-center gap-1.5">
            <Calendar className="h-3.5 w-3.5" />
            {formatDate(article.published_at || article.source_date)}
          </span>
          {article.locations?.length > 0 && (
            <span className="flex items-center gap-1.5">
              <MapPin className="h-3.5 w-3.5" />
              {article.locations[0]}
            </span>
          )}
        </div>
        <span className="mt-4 inline-flex items-center gap-2 text-emerald-700 font-medium text-sm">
          Read More <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
        </span>
      </div>
    </Link>
  </RevealItem>
);

export default ArticleCard;
